module.exports = __webpack_public_path__ + "static/media/nitro1.23bdb828.gif";